// Inventory.js
import React, { useState } from "react";
import axios from "../api/axios";
import Sidebar from "../components/Sidebar";

const Inventory = () => {
  const [file, setFile] = useState(null);

  const handleUpload = async () => {
    if (!file) return alert("Selecciona un archivo.");
    const formData = new FormData();
    formData.append("file", file);

    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/axios/inventory/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      alert("Inventario actualizado correctamente.");
    } catch (error) {
      alert("Error al subir el archivo.");
    }
  };

  const handleDownload = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/axios/inventory/download`, {
        responseType: "blob"
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "inventario.xlsx");
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      alert("Error al descargar el inventario.");
    }
  };

  return (
    <div className="min-h-screen p-6 flex flex-col bg-gray-100 items-center">
      <div className="bg-white shadow-lg rounded-lg p-6 border border-blue-600 w-full max-w-md">
        <h1 className="text-3xl font-bold mb-4">Administrar Inventario</h1>
        <input type="file" onChange={(e) => setFile(e.target.files[0])} className="mb-4" />
        <button onClick={handleUpload} className="bg-blue-600 text-white py-2 px-4 rounded-md mr-2">
          Subir Inventario
        </button>
        <button onClick={handleDownload} className="bg-green-600 text-white py-2 px-4 rounded-md">
          Descargar Inventario
        </button>
      </div>
    </div>
  );
};

export default Inventory;
